import { createContext } from "react";

/**
 * The already resolved workspace id, shared with the views subtree. Filled in by
 * WorkspaceIdProvider (mounted by ViewWrapper), read through useWorkspaceId.
 */
export const WorkspaceIdContext = createContext<string | undefined>(undefined);
